export default "__VITE_ASSET__D4r1lFGA__"